export default __webpack_public_path__ + "static/media/lady-employee-doing-video-meeting-2194238-0.8c654236.svg";